import { from, of, Subject } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { unified } from 'unified';
import remarkHtml from 'remark-html';
import remarkParse from 'remark-parse';

let transform = unified()
    .use(remarkParse)
    .use(remarkHtml);

export function md2html(md) {
    return from(transform.process(md)).pipe(
        map(html => String(html)),
    );
}
